export default __webpack_public_path__ + "static/media/expl_04_DE.8ab8f511.png";